const localPartPattern = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*$/i;
const domainLabelPattern = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/i;

/**
 * @param {string} value
 */
export const getEmailValidationError = value => {
  if (typeof value !== 'string') return 'invalid_type';
  if (value.length > 254) return 'too_long';
  if (/\s/.test(value)) return 'contains_whitespace';
  // eslint-disable-next-line no-misleading-character-class
  if (/[\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF\u0300-\u036F]/.test(value)) return 'contains_accent';

  const parts = value.split('@');
  if (parts.length === 1) return 'missing_at_sign';
  if (parts.length > 2) return 'multiple_at_signs';

  const [local, domain] = parts;
  if (!local) return 'missing_local_part';
  if (local.length > 64) return 'local_part_too_long';
  if (local.startsWith('.')) return 'local_part_starts_with_dot';
  if (local.endsWith('.')) return 'local_part_ends_with_dot';
  if (!localPartPattern.test(local)) return 'invalid_local_part';
  if (!domain) return 'missing_domain';

  const labels = domain.split('.');
  const topLevelDomain = labels[labels.length - 1];
  if (labels.length < 2) return 'domain_requires_dot';
  if (!labels.every(label => domainLabelPattern.test(label))) return 'invalid_domain_label';
  if (!/[a-z]/i.test(topLevelDomain)) return 'top_level_domain_invalid';
  if (topLevelDomain.length < 2) return 'top_level_domain_too_short';

  return null;
};

export const isValidEmail = value => getEmailValidationError(value) === null;
